import React, { FC, useContext, useRef, useState } from 'react';
import { GiftedChatMessage } from '../../../components/DiscussionMessages/DiscussionMessagesComponent';
import { Box, CircularProgress } from '@material-ui/core';
import { IUserContext, UserContext } from '../../../providers/UserProvider';
import { MAX_INPUT_LENGTH } from '../../../constants/common';
import CustomInputToolbar from './CustomInputToolbar';
import CustomBubble from './CustomBubble';
import {
  BubbleProps,
  GiftedChat,
  InputToolbarProps,
  Time,
  TimeProps,
} from 'react-web-gifted-chat';
import { SendMessageToDiscussionInput } from '../../../types/graphql-global-types';
import useStyles from './styles';
import CustomInputToolbarHeader from './CustomInputToolbarHeader/CustomInputToolbarHeader';

interface ICustomChatRoom {
  isLoadingNewMessage?: boolean;
  sendMessageLoading: boolean;
  messages: GiftedChatMessage[];
  title: string;
  onSendMessageText: (
    input: Partial<SendMessageToDiscussionInput> | undefined,
  ) => void;
  handleLoadEarlier: () => void;
  loadEarlier: boolean;
  disabled?: boolean;
}

const CustomChatRoom: FC<ICustomChatRoom> = (props) => {
  const {
    handleLoadEarlier,
    sendMessageLoading,
    onSendMessageText,
    title,
    messages,
    isLoadingNewMessage,
    loadEarlier,
    disabled,
  } = props;

  const classes = useStyles();

  const {
    me: { id: meId },
  } = useContext<IUserContext>(UserContext);

  const giftedChat = useRef<any>(null);

  const [input, setInput] = useState<
    Partial<SendMessageToDiscussionInput> | undefined
  >();

  const [quotedMessage, setQuotedMessage] = useState<
    GiftedChatMessage | undefined
  >(undefined);

  const renderTime = (_: TimeProps<GiftedChatMessage>) => (
    <Time
      {..._}
      textStyle={{
        left: {
          color: '#87888A',
        },
        right: {
          color: '#87888A',
        },
      }}
    />
  );

  const renderInputToolbar = (props: InputToolbarProps) => (
    <>
      {quotedMessage && (
        <CustomInputToolbarHeader
          quotedMessage={quotedMessage}
          onUnquoteMessage={() => setQuotedMessage(undefined)}
        />
      )}
      <CustomInputToolbar
        {...props}
        disabled={disabled}
        isSendingMessage={sendMessageLoading}
        isInputHaveValue={(input?.text?.length ?? 0) > 0}
        onSend={() => {
          onSendMessageText({
            ...input,
            quotedFromId: quotedMessage?.id,
          });
          setInput(undefined);
          setQuotedMessage(undefined);
        }}
      />
    </>
  );

  const renderBubble = (props: BubbleProps<GiftedChatMessage>) => (
    <CustomBubble
      disabled={disabled}
      {...props}
      onRespond={(message) => {
        setQuotedMessage(message);
      }}
    />
  );

  if (!messages?.length && isLoadingNewMessage)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box className={classes.wrapper}>
      <GiftedChat
        textInputProps={{
          style: {
            flex: 1,
            borderWidth: 1,
            borderColor: '#0000000D',
          },
        }}
        placeholder={
          isLoadingNewMessage
            ? 'Chargement du nouveau message...'
            : 'Envoyer un message...'
        }
        ref={(gitfted) => (giftedChat.current = gitfted)}
        onInputTextChanged={(text: string) =>
          setInput((prev) => ({ ...prev, text }))
        }
        renderTime={renderTime}
        renderInputToolbar={renderInputToolbar}
        renderBubble={renderBubble}
        messages={messages}
        text={input?.text ?? ''}
        user={{
          id: meId ?? -1,
        }}
        renderAvatarOnTop={true}
        renderLoading={() => <CircularProgress />}
        renderLoadEarlier={() => <CircularProgress />}
        loadEarlier={loadEarlier}
        onLoadEarlier={handleLoadEarlier}
        maxInputLength={MAX_INPUT_LENGTH}
      />
    </Box>
  );
};

export default CustomChatRoom;
